// Misma fórmula que el backend (lista de precios y análisis de mercado): polietileno de
// densidad 0,92, dos caras de la bolsa, medidas en cm y espesor en micrones.
export const bagWeightGrams = (widthCm: number, lengthCm: number, microns: number): number | null => {
  const w = Number(widthCm), l = Number(lengthCm), m = Number(microns);
  if (!(w > 0) || !(l > 0) || !(m > 0)) return null;
  return (w * l * m * 2 * 0.92) / 10000;
};

// El peso se calcula en gramos pero se muestra en kilos.
export const formatBagKg = (grams: number | null): string => (grams == null ? '-' : `${(grams / 1000).toLocaleString('es-AR', { maximumFractionDigits: 3 })} kg`);

export const formatKg = (kg: number): string => `${kg.toLocaleString('es-AR', { maximumFractionDigits: 2 })} kg`;

export const parseMeasure = (text: string): { widthCm: number; lengthCm: number } | null => {
  const match = String(text || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
  if (!match) return null;
  return { widthCm: Number(match[1].replace(',', '.')), lengthCm: Number(match[2].replace(',', '.')) };
};

// "Negras", "negro", "Negra" → "negro"; se compara por las primeras letras del color.
const COLOR_PREFIXES: Record<string, string> = { neg: 'negro', bla: 'blanco', azu: 'azul', ver: 'verde', roj: 'rojo' };
export const colorKeyFromLabel = (label: string): string => COLOR_PREFIXES[String(label || '').trim().toLowerCase().slice(0, 3)] || String(label || '').trim().toLowerCase();
